import React, { useState, useEffect, useRef } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        if (isMountedRef.current) {
          handleClose();
        }
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleClose = () => {
    if (!isMountedRef.current) return;

    setIsExiting(true);
    setTimeout(() => {
      if (isMountedRef.current) {
        setIsVisible(false);
        if (onClose) onClose();
      }
    }, 300); // Match animation duration
  };

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'info':
        return 'fas fa-info-circle';
      default:
        return 'fas fa-check-circle';
    }
  };

  return (
    <div
      className={`toast toast-${type} ${isExiting ? 'toast-exit' : ''}`}
      onClick={handleClose}
    >
      <div className="toast-content">
        <i className={`toast-icon ${getIcon()}`}></i>
        <span className="toast-message">{message}</span>
        <button className="toast-close" onClick={handleClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default Toast;
